module.exports = __webpack_public_path__ + "img/get-help.96cac25f.svg";